const mockTranslator = (key: string) => key

/**
 * Get the global raw translator (t function) from the window object.
 * NOTE: It's be used only in scenarios where the useTranslations hook is not available or not applicable.
 */
export const getRawTranslator = () => window.cdcMarketTranslator ?? mockTranslator
